import { render } from "./ExamResultModal.vue?vue&type=template&id=4407eab7&scoped=true"
import script from "./ExamResultModal.vue?vue&type=script&lang=js"
export * from "./ExamResultModal.vue?vue&type=script&lang=js"

import "./ExamResultModal.vue?vue&type=style&index=0&id=4407eab7&lang=scss&scoped=true"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4407eab7"]])

export default __exports__